const features = [
  {
    icon: 'ri-global-line',
    title: '全网瓜料聚合',
    desc: '实时抓取全网娱乐八卦黑料，跨平台智能聚合，一站浏览不再东奔西跑，确保您第一时间获取最新瓜料动态。',
  },
  {
    icon: 'ri-search-eye-line',
    title: '深度事件深扒',
    desc: '专业内容团队深度挖掘事件背景与来龙去脉，还原事件全貌，让每一条瓜料都有据可查、有理有据。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '匿名投稿保护',
    desc: '严格保护爆料人隐私安全，采用多重匿名机制处理投稿信息，让您放心爆料无后顾之忧。',
  },
];

export default function Features() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            为什么选择吃瓜黑料爆料
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            三个核心优势，打造最值得信赖的娱乐八卦聚合平台
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {features.map((item, i) => (
            <div
              key={i}
              className="group bg-background-50 border border-background-200/70 rounded-xl p-6 md:p-8 hover:border-primary-200 transition-all duration-300"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-50 text-primary-500 mb-5 group-hover:bg-primary-500 group-hover:text-white transition-colors duration-300">
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <h3 className="text-lg font-bold text-foreground-950 mb-2 font-heading">
                {item.title}
              </h3>
              <p className="text-foreground-500 text-sm leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}